<template>
  <div class="song-list-editor">
    <draggable class="song-list" :options="sortOptions" :list="songs" :disabled="!canSort" @change="onChange">
      <b-row class="song" align-v="center" v-for="song in songs" :key="song.id">
        <b-col cols="*" class="grip" v-if="canSort">
          <font-awesome-icon icon="th"></font-awesome-icon>
        </b-col>
        <b-col cols="*">
          <router-link :to="{name: 'video-detail', params: {id: song.id}}"><img :src="getThumbnail(song)"></router-link>
        </b-col>
        <b-col>
          <router-link :to="{name: 'video-detail', params: {id: song.id}}">{{ song.title }}</router-link>
        </b-col>
        <b-col cols="*">
          {{ formatDuration(song) }}
        </b-col>
        <b-col cols="*" v-if="canRemove">
          <font-awesome-icon icon="times" class="remove" @click="removeSong(song)"></font-awesome-icon>
        </b-col>
      </b-row>

    </draggable>

    <b-row v-if="canAdd">
      <b-col class="add-song-btn" v-if="!addingSong" @click="addingSong=true">
        <font-awesome-icon icon="plus"></font-awesome-icon>
        &nbsp;
        Add song
      </b-col>
      <b-col class="add-song-btn" v-else>
        <multiselect :searchable="false"
                     :multiple="false"
                     :showNoResults="false"
                     label="title"
                     :options="availableSongs"
                     @select="addSong"
                     @close="addingSong=false">
        </multiselect>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  .song-list-editor {
    margin-left: 15px;
    margin-right: 15px;
  }

  .song {
    border-bottom: 1px solid $slate-blue;
    padding-bottom: 10px;
    margin-bottom: 10px;

    .grip {
      color: $steel;

      &:hover {
        color: $white;
      }
    }

    .remove {
      margin-left: 1em;

      &:hover {
        color: red;
        cursor: pointer;
      }
    }

    img {
      margin-left: 1em;
      width: 100px;
      height: 56px;
      object-fit: cover;
    }

    a {
      color: $white;
    }
  }

  .col.add-song-btn {
    border: 1px dashed $steel;
    text-align: center;
    font-weight: bold;
    cursor: pointer;
    padding: 0.5em;
  }

</style>

<script>
import Multiselect from 'vue-multiselect'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import draggable from 'vuedraggable'

import { songHelpers } from '@/store/helpers'

export default {
  name: 'SongListEditor',
  model: {
    prop: 'songs',
    event: 'change'
  },
  props: {
    songs: Array,
    canAdd: Boolean,
    canRemove: Boolean,
    canSort: Boolean,
    availableSongs: Array
  },
  components: {
    FontAwesomeIcon,
    Multiselect,
    draggable
  },
  data () {
    return {
      addingSong: false,
      sortOptions: {
        handle: '.grip'
      }
    }
  },
  methods: {
    addSong (song) {
      this.addingSong = false
      this.songs.push(song)
      this.onChange()
    },
    removeSong (song) {
      let idx = this.songs.indexOf(song)
      if (idx !== -1) {
        this.songs.splice(idx, 1)
        this.onChange()
      }
    },
    onChange () {
      this.$emit('change', this.songs)
    },
    ...songHelpers
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/SongListEditor.vue